import { makeAutoObservable } from "mobx"
import { arrayRemoveDuplicates } from "react-sdk/utils"

export class Slide {
  id
  PopupID
  surtitle
  title
  image
  Text
  caption
  constructor(json) {
    Object.assign(this, json)
    makeAutoObservable(this)
  }
}


class Slides {

  /** @type {Array<Slide>} */
  all = []

  init(json) {
    this.all = json
    .filter(elem => elem.id).map(elem => new Slide(elem))
  }

  get ids() { return this.all.map(c => c.id)}

  get slidesIds () {
    return arrayRemoveDuplicates(this.all.map(s => s.PopupID))
  }
  get(id) { return this.all.filter(ftue => ftue.PopupID === id) }

}


export default new Slides()